export const lightTheme = {
    mainBg: "#ffffff",  // white
    textOne: "#000000", // black
    textTwo: "#606060",  // light gray
    textThree: "#0d63d5",
    videoSmallText: "#1f1f1f",  // lightgray two
    menuText: "#000000", // black
    menuHover: "#e6e6e6",
    subButtonBg: "#000000",  // black
    subButtonText: "#ffffff", // white
    descriptionBg: "#f2f2f2",  // light gray three
    descriptionLinkBg: "#e6e6e6", // light gray four
    commentInputBorder: "#f2f2f2", // light gray five
    commentTime: "#8c8c8c", // light gray six
    commentTimeHover: "#0f0f0f", // dark gray
    buttonOneBg: "#f0f0f0", // medium gray
    buttonOneBorder: "#cccccc",
    signInButonText: "#065fd4",
    signInButtonBg: "#def1ff",
    replyButtonText: "#065fd4",  // blue
    replyButtonBgHover: "#def1ff",
    border: "#f0f0f0", // light blue
    sideMenuBg: "#ffffff",
    sideMenuHover: "#f2f2f2",
    chatName: "#6b6b6b",
}

export const darkTheme = {
    mainBg: "#0f0f0f",
    textOne: "#faf7f7",
    textTwo: "#878787",
    textThree: "#3da2f9",
    smallText: "#606060",
    videoSmallText: "#1f1f1f",
    menuText: "#ffffff",
    menuHover: "#272727",
    subButtonBg: "#ffffff",
    subButtonText: "#000000",
    descriptionBg: "#2b2a2a",
    descriptionLinkBg: "#3e3e3e",
    commentInputBorder: "#3f3f3f",
    commentTime: "#606060",
    commentTimeHover: "#ffffff",
    buttonOneBg: "#272727",
    buttonOneBorder: "#222222",
    signInButonText: "#ffffff",
    signInButtonBg: "#0f0f0f",
    replyButtonText: "#065fd4",
    replyButtonBgHover: "#263850",
    border: "#3f3f3f",
    sideMenuBg: "#282828",
    sideMenuHover: "#3e3e3e",
    chatName: "#b7b7b7"
}
